module.exports = __webpack_public_path__ + "static/media/162-germany.7bb96171.svg";